// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui';

/* 路由 */
import router from './router'

/* axios */
import axios from './api'
import api from './api/api'
import store from './store'

Vue.prototype.http = axios;
Vue.prototype.api = api;
Vue.prototype.$store = store

if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
  Vue.prototype.$h5 = true // 手机端
} else {
  Vue.prototype.$h5 =  false // alert('PC端')
}

// 判断是否为移动端
// Vue.prototype.$h5 = !navigator.userAgent.includes('Windows')



/* swiper */
import 'swiper/dist/css/swiper.min.css';

// vue-awesome-swiper
import VueAwesomeSwiper from 'vue-awesome-swiper';
Vue.use(VueAwesomeSwiper)

/* 重置样式 */
import './assets/css/reset.min.css'

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

/* animate.css */
import 'animate.css'

// element.css
import 'element-ui/lib/theme-chalk/index.css'

// public.css
import './assets/css/public.scss'

 
/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name,Header)


/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name,Footer)

/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name,GoTop)
/* 移动端回到顶部 */
import GoTop2 from './components/GoTop2'
Vue.component(GoTop2.name,GoTop2)

/* 联系我们 */
import cover from './components/cover'
Vue.component(cover.name,cover)
// loading组件
import Loading from './components/Loading'
Vue.component(Loading.name, Loading)

// 小标题组件
import Title from './components/Title'
Vue.component(Title.name, Title)

// 产品与服务咨询组件
import SubmitForm from './components/SubmitForm'
Vue.component(SubmitForm.name, SubmitForm)

Vue.config.productionTip = false

Vue.use(ElementUI, { size: 'medium', zIndex: 3000 });

// router.beforeEach((to, from, next) => {
//     if(to.meta.title){
//       document.title = to.meta.title
//     }
//     next();
// });

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})


new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js